// bp (10000 = 1.00x) applied to the vehicle's full-coverage footage/minutes
// baseline for each coverage level. 'spot' has no factor - it uses the
// caller-supplied spotFtX10/spotMinutes directly instead of scaling the base.
export const PRINT_COVERAGE_FACTOR = {
    full: 10000,
    three_quarter: 7500,
    half: 5000,
};
function roundHalfUp(n) {
    return Math.round(n);
}
function laborCentsFromMinutes(minutes, rateCentsPerHour) {
    return roundHalfUp((minutes * rateCentsPerHour) / 60);
}
function applyMarkup(cents, markupBp) {
    return roundHalfUp((cents * (10000 + markupBp)) / 10000);
}
export function pricePrintLine(input) {
    const isSpot = input.coverageLevel === 'spot';
    const factor = input.coverageLevel === 'spot' ? 0 : PRINT_COVERAGE_FACTOR[input.coverageLevel];
    // -- footage (ft_x10, reused as sqft_x10 - see module comment) ----------
    const ftX10 = isSpot ? input.spotFtX10 : roundHalfUp((input.vehicleBaseFtX10 * factor) / 10000);
    const sqftX10 = roundHalfUp((ftX10 * (10000 + input.wasteBp)) / 10000);
    // -- material: print media + laminate, each rounded and marked up on its
    // own (rather than on the combined base) so their breakdown entries always
    // sum exactly to materialCostCents with no leftover drift to reconcile.
    const mediaCostCents = applyMarkup(roundHalfUp((sqftX10 * input.printMediaCentsPerSqft) / 10), input.markupBp);
    const laminateCostCents = applyMarkup(roundHalfUp((sqftX10 * input.laminateCentsPerSqft) / 10), input.markupBp);
    const materialCostCents = mediaCostCents + laminateCostCents;
    // -- outsourced print production cost, its own markup -------------------
    const printCostBeforeMarkup = roundHalfUp((sqftX10 * input.printCostCentsPerSqft) / 10);
    const printCostCents = applyMarkup(printCostBeforeMarkup, input.markupBp);
    // -- labor minutes --------------------------------------------------------
    const installMinutes = isSpot
        ? input.spotMinutes
        : roundHalfUp((((input.vehicleBaseMinutes * factor) / 10000) * input.complexityBp) / 10000);
    const removalMinutes = input.removalTier === 'none' ? 0 : input.removalMinutesByTier[input.removalTier];
    const laborMinutes = installMinutes + removalMinutes;
    const laborCostCents = laborCentsFromMinutes(laborMinutes, input.laborRateCentsPerHour);
    // -- design ---------------------------------------------------------------
    const designCostCents = input.designMode === 'flat'
        ? input.designFlatCents
        : input.designMode === 'hourly'
            ? laborCentsFromMinutes(input.designMinutes, input.designRateCentsPerHour)
            : 0;
    const fixedAddOnCents = input.fixedAddOnCents;
    const entries = [];
    if (mediaCostCents > 0)
        entries.push({ label: 'Print media', cents: mediaCostCents });
    if (laminateCostCents > 0)
        entries.push({ label: 'Laminate', cents: laminateCostCents });
    if (printCostCents > 0)
        entries.push({ label: 'Print production', cents: printCostCents });
    entries.push({ label: 'Installation labor', minutes: installMinutes, cents: laborCentsFromMinutes(installMinutes, input.laborRateCentsPerHour) });
    if (removalMinutes > 0)
        entries.push({ label: 'Removal', minutes: removalMinutes, cents: laborCentsFromMinutes(removalMinutes, input.laborRateCentsPerHour) });
    if (designCostCents > 0)
        entries.push({ label: 'Design', minutes: input.designMode === 'hourly' ? input.designMinutes : undefined, cents: designCostCents });
    if (fixedAddOnCents > 0)
        entries.push({ label: 'Add-ons', cents: fixedAddOnCents });
    const lineSubtotalCents = entries.reduce((acc, e) => acc + e.cents, 0);
    const estimatedMinutes = laborMinutes + (input.designMode === 'hourly' ? input.designMinutes : 0);
    return {
        labor: [{ label: 'labor', minutes: laborMinutes, cents: laborCostCents }],
        estimatedMinutes,
        filmFtX10: sqftX10,
        materialCostCents,
        laborCostCents,
        designCostCents,
        printCostCents,
        lineSubtotalCents,
        breakdown: { entries },
    };
}
//# sourceMappingURL=print.js.map